'use client';
import '@/resources/css/app.css';
import './globals.css';
import { Providers } from './providers';

import { useLocaleSync } from '@/hooks/useLocaleSync';
import StatusBarUpdater from '@/components/StatusBarUpdater';

function AppContent({ children }: { children: React.ReactNode }) {
  useLocaleSync();
  return <>{children}</>;
}

export default function RootLayout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        {/* Enable full-screen PWA on iOS */}
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-title" content="FlightDeck" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
        <meta name="format-detection" content="telephone=no" />

        {/* Icons */}
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="192x192" href="/android-chrome-192x192.png" />
        <link rel="icon" type="image/png" sizes="512x512" href="/android-chrome-512x512.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="shortcut icon" href="/favicon.ico" />

        {/* Manifest */}
        <link rel="manifest" href="/manifest.webmanifest" />

        {/* Dynamic Colors */}
        <meta name="msapplication-TileImage" content="/android-chrome-192x192.png" />

      </head>
      <body>
        <Providers>
          <StatusBarUpdater />
          <AppContent>{children}</AppContent>
        </Providers>
      </body>
    </html>
  );
}
